<template>
  <div class="cookie-popup">
    <div class="cookie-popup__container">
      <span class="cookie-popup__title">We value
        <br class="cookie-popup__mobile-break"> your privacy
      </span>

      <picture class="cookie-popup__picture">
        <source srcset="/images/cookies-image@2x.png 2x, /images/cookies-image.png 1x">
        <img
          class="cookie-popup__image"
          src="/images/cookies-image.png"
          alt="cookies">
      </picture>
    </div>

    <div class="cookie-popup__container">
      <p
        v-if="isEU"
        class="cookie-popup__text">
        We use cookies for a safe and smooth experience on our site.
        They help us protect your data, personalise your content or ads,
        measure marketing campaigns, and analyse our traffic. Click 'Accept all’
        to consent to our use of cookies, or ‘Manage cookies’ to adjust your settings.
        Learn more in our

        <router-link
          to="/cookie"
          class="cookie-popup__policy-link">
          Cookie Policy
        </router-link>
      </p>
      <p
        v-else
        class="cookie-popup__text">
        Cookies are important for our website to operate properly.
        To learn more about cookies and data we collect, check out our

        <router-link
          to="/privacy"
          class="cookie-popup__policy-link">
          Privacy Policy
        </router-link>
        and
        <router-link
          to="/cookie"
          class="cookie-popup__policy-link">
          Cookies Policy
        </router-link>
      </p>
    </div>

    <div class="cookie-popup__container-buttons">
      <button
        v-if="isEU"
        class="button cookie-popup__button cookie-popup__button-manage"
        type="button"
        @click="$emit('manage-cookies')">
        Manage cookies

        <img
          src="/images/icons/arrow-simple.svg"
          alt="arrow-simple"
          class="cookie-popup__button-manage-icon">
      </button>

      <button
        v-else
        class="button cookie-popup__button cookie-popup__button-manage"
        type="button"
        @click="$emit('close')">
        Close
      </button>

      <button
        class="button button-main cookie-popup__button"
        type="button"
        @click="$emit('accept-all')">
        {{ isEU ? 'Accept all' : 'Accept' }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InitialCookiePopup',

  props: {
    isEU: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      isSmallPopupVisible: false,
    };
  },
};
</script>

<style scoped lang="scss">
.cookie-popup {
  grid-row-gap: 16px;
  max-width: 416px;
}

.cookie-popup__container {
  display: grid;
  grid-auto-flow: column;
  grid-column-gap: 16px;
}

.cookie-popup__picture {
  justify-self: end;
}

.cookie-popup__container-buttons {
  display: grid;
  grid-auto-flow: column;
  grid-column-gap: 16px;
  grid-template-columns: repeat(2, 1fr);
  grid-template-areas: "manage accept";

  .button {
    &:first-child {
      grid-area: manage;
    }

    &:last-child {
      grid-area: accept;
    }
  }
}

.cookie-popup__button {
  font-size: 15px;
  padding: 11px 0;
}

.cookie-popup__button-manage {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid $color--basic-menu;
}

.cookie-popup__button-manage-icon {
  margin-left: 8px;
  width: 24px;
  height: 24px;
  transform: rotate(90deg)
}

.mobile-break {
  display: none;
}

@media screen and #{$screen-less-than-480} {
  .cookie-popup__container-buttons {
    grid-template-areas: "accept" "manage";
  }

  .cookie-popup__container {
    align-items: center;
  }

  .cookie-popup__image {
    max-width: 70px;
  }

  .cookie-popup__button-manage-icon {
    width: 16px;
    height: 16px;
  }

  .cookie-popup__mobile-break {
    display: block;
  }
}
</style>
